import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import * as S from './styled'

const modalityMessage = ({ cost, deadlineMessage, deadlinePrefix, type }) => {
  if (type === 'scheduled') {
    return <span>Agende para receber por <S.BoldText className="cost">{formatPriceToBRL(cost)}</S.BoldText></span>
  }

  return <span>{deadlinePrefix}: <S.BoldText>{deadlineMessage}</S.BoldText> por <S.BoldText className="cost">{formatPriceToBRL(cost)}</S.BoldText></span>
}

const ShipmentModalities = ({ modalities = [] }) => {
  return (
    <div>
      {modalities.map((modality, i) => (
        <S.DeadlineBox key={i}>
          {modalityMessage(modality)}
        </S.DeadlineBox>
      ))}
    </div>
  )
}

export default ShipmentModalities
